import api from './api';

export const fetchCustomerRequests = async (params = {}) => {
  const response = await api.get('/customer-request', { params });
  return response.data;
};

export const fetchCustomerRequestByProjectCode = async (projectCode) => {
  const response = await api.get(`/customer-request/${projectCode}`);
  return response.data;
};

export const fetchDeliveryRequests = async (params = {}) => {
  const response = await api.get('/delivery-request', { params });
  return response.data;
};

export const deleteDeliveryRequests = async (ids) => {
  const response = await api.delete('/delivery-request/bulk', {
    data: { ids }
  });
  return response.data;
};

export const terminateProjects = async (ids) => {
  const response = await api.patch('/delivery-request/terminate', {
    ids
  });
  return response.data;
};

export const fetchWorkOrders = async (params = {}) => {
  const response = await api.get('/work-order', { params });
  return response.data;
};



export const fetchDetailedInvoices = async (params = {}) => {
  const response = await api.get('/invoice/detailed', { params });
  return response.data;
};

export const fetchSummaryInvoices = async (params = {}) => {
  const response = await api.get('/invoice/summary', { params });
  return response.data;
};

export const fetchEfforts = async (params = {}) => {
  const response = await api.get('/effort', { params });
  return response.data;
};

export const fetchProjectModels = async (projectCode) => {
  const response = await api.get(`/projects/${projectCode}/models`);
  return response.data;
};

export const addCustomerRequest = async (customerRequestData) => {
  const response = await api.post('/customer-request/addCustomerrequest', customerRequestData);
  return response.data;
};

export const fetchBusinessGroups = async () => {
  const response = await api.get('/customer-request/business-groups');
  return response.data;
};

export const fetchDepartments = async () => {
  const response = await api.get('/customer-request/departments');
  return response.data;
};

export const fetchBudgetCodes = async () => {
  const response = await api.get('/customer-request/budget-codes');
  return response.data;
};

export const fetchCustomerByBudgetCode = async (budgetCode) => {
  const response = await api.get(`/customer-request/customer/${encodeURIComponent(budgetCode)}`);
  return response.data;
};

export const fetchTypeOfWork = async () => {
  const response = await api.get('/customer-request/type-of-work');
  return response.data;
};

export const fetchModels = async () => {
  const response = await api.get('/models/search');
  return response.data;
};

export const submitCRF = async (crfData) => {
  const response = await api.post('/customer-request/submit', crfData);
  return response.data;
};

export const terminateCustomerRequests = async (projectCodes) => {
  const response = await api.post('/customer-request/terminate', { projectCodes });
  return response.data;
};

export const fetchCustomerRequestDetails = async (projectCode) => {
  const response = await api.get(`/customer-request/details/${projectCode}`);
  return response.data;
};

export const updateCustomerRequest = async (projectCode, updateData) => {
  const response = await api.put(`/customer-request/${projectCode}`, updateData);
  return response.data;
};

export const fetchModelDetails = async (projectCode) => {
  const response = await api.get(`/customer-request/models/${projectCode}`);
  return response.data;
};

export const detailedInvoiceService = {
  getProjectCodes: async (projectCode) => {
    const response = await api.get('/invoice/detailed/project-codes', { params: { projectCode } });
    return response.data;
  },
  getProjectCodesByDept: async (projectType) => {
    const response = await api.get('/invoice/detailed/project-codes-by-dept', { params: { projectType } });
    return response.data;
  },
  getDetailedInvoice: async (projectCode) => {
    const response = await api.get(`/invoice/detailed/${projectCode}`);
    return response.data;
  },
  submitInvoice: async (invoiceData, sendEmail = true) => {
    const response = await api.post('/invoice/detailed/submit', invoiceData, {
      params: { send: sendEmail ? 'y' : 'n' }
    });
    return response.data;
  },
  approveInvoice: async (invoiceData) => {
    const response = await api.post('/invoice/detailed/approve', invoiceData);
    return response.data;
  },
  verifyEffortChangeFlag: async (projectCode) => {
    const response = await api.get(`/invoice/detailed/effort-change/${projectCode}`);
    return response.data;
  }
};